import { getVccTooltipText } from 'app/components/pages/Extranet/ExtranetBookings/common/utils/vccTooltip';
import type { PAX } from 'app/typings/PAX';
import type {
  ExtranetHotelOldPack,
  ExtranetHotelPack,
} from 'app/typings/core/extranet/hotel/packs';
import { pluralize } from 'app/utils/strings';

const formatAdults = (adults: number) => pluralize(adults, 'adult', 'adults');

const formatChildren = (children: number) =>
  pluralize(children, 'child', 'children');

const formatBabies = (babies: number) => pluralize(babies, 'baby', 'babies');

export const formatPax = (customer: PAX) => {
  const parts = [];

  if (customer.adults > 0) {
    parts.push(formatAdults(customer.adults));
  }

  if (customer.children > 0) {
    parts.push(formatChildren(customer.children));
  }

  if (customer.babies > 0) {
    parts.push(formatBabies(customer.babies));
  }

  return parts.join(', ');
};

export const getTooltipText = getVccTooltipText;

export type PackageFilterOption = {
  text: string;
  value: string;
};

export type PackageFilterGroup = {
  title: string;
  options: PackageFilterOption[];
};

export const getPackageFilterGroups = (
  packsList: ExtranetHotelPack[],
  oldPacksList: ExtranetHotelOldPack[]
): PackageFilterGroup[] => {
  const daytime: PackageFilterOption[] = [];
  const night: PackageFilterOption[] = [];
  const push = (isDaytime: boolean, text: string, id: number) =>
    (isDaytime ? daytime : night).push({ text, value: String(id) });

  packsList.forEach((p) => push(p.isDaytime, p.nameForHotel, p.id));
  oldPacksList.forEach((p) => push(p.dayPackage, p.aliasForHotel, p.id));

  return [
    { title: 'Daytime', options: daytime },
    { title: 'Night stay', options: night },
  ].filter((group) => group.options.length > 0);
};
